<style scoped lang="scss">
.breads{
  overflow:auto;line-height: 48px;margin-bottom:  20px;
}
.desc{
  font-size: 16px;text-indent: 0;
}
.compose-type{
    background: #f6fafd;
    padding-bottom: 80px;
    margin-top: 100px;
}
@media screen and (max-width: 640px) {
  .compose-type {
    margin-top: 50px;
    padding-bottom: 30px;
  }
}
</style>
<style scoped>
@import url("../../assets/sanger.css");
@import url("../../assets/service.css");
</style>
<template>
  <!--  基因合成-标准基因合成 -->
  <div class="wrap wrap-tec">
    <router-view></router-view>
    <!-- banner -->
    <gene-top-banner :smallTitle="smallTitle" :bigTitle="bigTitle"></gene-top-banner>
    <section v-if="!$route.meta.invisibles">
      <!-- 导航 -->
      <div class="breads container">
        <bread></bread>
      </div>
      <!-- 概述 -->
      <div class="container">
        <p class="desc">相比于传统的质粒构建方法，基因合成在节省时间和精力方面具有显著优势。擎科生物提供定制化基因合成服务，无论是标准基因合成还是基因组合成，您只需提供所需的DNA序列，我们将为您提供从密码子优化/序列优化到完整质粒交付的一站式服务，满足您的研究需求。</p>
      </div>
      <!-- 产品优势 -->
      <div class="compose-type">
        <div class="container">
          <en-title title="产品优势" enTitle="Advantages"></en-title>
          <gene-advantages :menuTitle="bigTitle" :advantagesList="advantagesList" ></gene-advantages>
        </div>
      </div>
      <!-- 服务内容 -->
      <div class="container">
        <en-title title="服务内容" enTitle="Service Details"></en-title>
        <gene-detail-table :tableColumn="tableColumn" :tableData="tableData" :tableSpanMethod="tableSpanMethod"></gene-detail-table>
      </div>
      <!-- 交付结果 -->
      <div class="container">
        <en-title title="交付结果" enTitle="Deliverables"></en-title>
        <gene-deliverables :products="products" :reports="reports"></gene-deliverables>
      </div>
      <!-- 订购与咨询 -->
      <div class="container">
          <new-consult type="gene" :typeList="['orderOnline','telePhone','download','email']"></new-consult>
      </div>
    </section>
  </div>
</template>
<script>
import bread from "@/components/bread"
import GeneTopBanner from "./gene-components/geneTopBanner"
import EnTitle from '@/components/EnTitle'
import GeneAdvantages from './gene-components/geneAdvantages'
import GeneDetailTable from './gene-components/geneDetailTable'
import GeneDeliverables from './gene-components/geneDeliverables'
export default {
  components:{
    bread, 
    GeneTopBanner,
    EnTitle,
    GeneAdvantages,
    GeneDetailTable,
    GeneDeliverables,
  },
  data () {
    return {
      smallTitle:'全基因组合成',
      bigTitle:'标准基因合成',
      advantagesList:[
        {
          img:'gene_second/standard_page/icon_1',
          title:'高交付率',
          text:'交付率>99.5%',
        },
        {
          img:'gene_second/standard_page/icon_2',
          title:'高准确率',
          text:'Sanger测序与NGS双重QC\n保障序列准确无误',
        },
        {
          img:'gene_second/standard_page/icon_3',
          title:'免费载体库',
          text:'160+免费载体供选择',
        },
        {
          img:'gene_second/standard_page/icon_4',
          title:'免费密码子优化',
          text:'提供免费密码子优化服务',
        }
        
      ],
      tableColumn:[
        {
          label:'服务名称',
          prop:'serviceName',
        },
        {
          label:'基因长度',
          prop:'geneLength',
        },
        {
          label:'生产周期（工作日）',
          prop:'productionCycle',
        },
        {
          label:'载体',
          prop:'carrier',
        }
      ],
      tableData:[
        {
          serviceName:'标准基因合成',
          geneLength:'< 1.5 kb',
          productionCycle:'5 - 7',
          carrier:'若无特殊备注\n默认 pUC57',
        },
        {
          geneLength:'1.5 kb - 3.5 kb',
          productionCycle:'9 - 12',
        },
        {
          geneLength:'3.5 kb - 5 kb',
          productionCycle:'12 - 15',
        },
        {

          geneLength:'5 kb - 7 kb',
          productionCycle:'15 - 18',
        },
        {

          geneLength:'7 kb - 10 kb',
          productionCycle:'20 - 25',
        },
        {
          geneLength:'> 10 kb',
          productionCycle:'需要评估',
        },
      ],
      products:'冻干质粒 DNA 一管 ( 高拷贝约4 μg/ 管，低拷贝1-4 μg/ 管 )\n含有重组质粒的穿刺菌一管',
      reports:'测序图谱 (.abl 文件 )\n目标序列 (.seq 文件 )\nCOA 文件'
    }
  },
  methods: {
    tableSpanMethod({ row, column, rowIndex, columnIndex }){   
      if (columnIndex === 0){
        return {
          rowspan: row.serviceName ? 6 : 0,
          colspan: row.serviceName ? 1 : 0
        }
      }
      if (columnIndex === 3){
        return {
          rowspan: row.carrier ? 6 : 0,
          colspan: row.carrier ? 1 : 0
        }
      }
      
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/views/products/standard_page.vue